import { render, staticRenderFns } from "./CockpitBooleanComponent.vue?vue&type=template&id=5b9e641f&scoped=true"
import script from "./CockpitBooleanComponent.vue?vue&type=script&lang=js"
export * from "./CockpitBooleanComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9e641f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b9e641f')) {
      api.createRecord('5b9e641f', component.options)
    } else {
      api.reload('5b9e641f', component.options)
    }
    module.hot.accept("./CockpitBooleanComponent.vue?vue&type=template&id=5b9e641f&scoped=true", function () {
      api.rerender('5b9e641f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/entries/cockpitFormCompontents/CockpitBooleanComponent.vue"
export default component.exports